import { render, staticRenderFns } from "./UserMaintenancePayments.vue?vue&type=template&id=55d7ff06&scoped=true"
import script from "./UserMaintenancePayments.vue?vue&type=script&lang=js"
export * from "./UserMaintenancePayments.vue?vue&type=script&lang=js"
import style0 from "./UserMaintenancePayments.vue?vue&type=style&index=0&id=55d7ff06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d7ff06",
  null
  
)

export default component.exports